"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEvents = exports.Events = void 0;
var Events;
(function (Events) {
    Events["OptIn"] = "Opt In";
    Events["Identify"] = "identify";
    Events["Page"] = "page";
    Events["MembershipNotification"] = "member_notification";
    Events["DataLayerLoaded"] = "dataLayer-loaded";
    Events["OptimizeReady"] = "optimize.ready";
})(Events = exports.Events || (exports.Events = {}));
function isEvents(event) {
    return Object.values(Events).includes(event);
}
exports.isEvents = isEvents;
